import { ref } from 'vue';

/**
 * More than one list can be on screen at once — a gambit's attendees over a
 * spot's check-ins, a profile underneath both — and each of them watches for
 * handshakes offered to you. Which one notices first does not matter, but only
 * one may put a modal up, and an offer already shown is not shown again by the
 * others.
 */
const openModals = ref(0);
const shownHandshakeIds = new Set<string>();

export const isHandshakeModalOpen = (): boolean => openModals.value > 0;

export const markHandshakeModalOpen = (): void => {
  openModals.value += 1;
};

export const markHandshakeModalClosed = (): void => {
  openModals.value = Math.max(0, openModals.value - 1);
};

export const wasHandshakeShown = (handshakeId: string): boolean => shownHandshakeIds.has(handshakeId);

export const markHandshakeShown = (handshakeId: string): void => {
  shownHandshakeIds.add(handshakeId);
};
